import React, { useEffect, useState } from "react";
import { Col, Row, Form, Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import * as yup from "yup";
import { useFormik } from "formik";
import * as parseGooglePlace from "parse-google-place";
import Autocomplete from "react-google-autocomplete";
import {
  getBusinessCategories,
  getCountries,
  getStates,
  matchBusinessCategories,
} from "../../../../Services/public-service";
import {
  handleFormikChange,
  handleFormikSubmit,
  haveValue,
  underScoredToNormal,
} from "../../../../Utils/helpers";
import FormFieldSelect from "../../../FormFields/FormFieldSelect";
import FormField from "../../../FormFields/FormField";

const Step1Form = (props: any) => {
  const configurations = useSelector((state: any) => state.configurations);
  const vendor = configurations?.vendor;

  const [countries, setCountries]: any = useState([]);
  const [states, setStates]: any = useState([]);
  const [defaultBusinessCats, setDefaultBusinessCats]: any = useState([]);

  const [showCategory, setShowCategory]: any = useState(false);
  const [showContactInfoModal, setShowContactInfoModal]: any = useState(false);

  const handleModalClose = () => setShowContactInfoModal(false);
  const handleModalShow = () => setShowContactInfoModal(true);

  const [allValues, setAllValues] = useState({});

  const validationSchema = yup.object({
    businessName: yup.string().required("Company Name is required"),
    businessCategory: yup.string(),
    country: yup.string(),
    state: yup.string(),
    city: yup.string(),
    businessAddress: yup.string().required("Company Address is required"),
    zipcode: yup.string().required("Zip is required"),
    businessPhone: yup.string().required("Company Phone Number is required"),
    facebookHandle: yup.string(),
    instagramHandle: yup.string(),
    linkedInHandle: yup.string(),
    twitterHandle: yup.string(),
  });

  const validationSchema2 = yup.object({
    name: yup.string().required("Name is required"),
    email: yup
      .string()
      .email("Enter a valid Email Address")
      .required("Email is required"),
  });

  const form = useFormik({
    initialValues: {
      businessName: "",
      website: "",
      businessCategory: "",
      country: "",
      state: "",
      city: "",
      businessAddress: "",
      zipcode: "",
      businessPhone: "",
      facebookHandle: "",
      instagramHandle: "",
      linkedInHandle: "",
      twitterHandle: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      setAllValues(values);
      handleModalShow();
    },
  });

  const form2 = useFormik({
    initialValues: {
      name: "",
      email: "",
    },
    validationSchema: validationSchema2,
    onSubmit: (values) => {
      props.onSubmit({ ...values, ...allValues });
    },
  });

  const loadCountries = () => {
    getCountries()
      .then((res: any) => {
        let countriesData: any = [];
        for (let country of res.data) {
          countriesData.push({
            _id: country?.isoCode,
            name: country?.name,
          });
        }
        setCountries(countriesData);
      })
      .catch((error) => {});
  };

  const loadStates = (countryCode) => {
    getStates({
      countryCode,
    })
      .then((res: any) => {
        let statesData: any = [];
        for (let state of res.data) {
          statesData.push({
            _id: state.isoCode,
            name: state.name,
          });
        }
        setStates(statesData);
      })
      .catch((error) => {});
  };

  const handleCountryChange = (countryCode: any) => {
    loadStates(countryCode);
    handleFormikChange(countryCode, form, "country");
  };

  useEffect(() => {
    loadCountries();
  }, []);

  const onPlaceSelect = (place, ref) => {
    let address = parseGooglePlace(place);

    if (!haveValue(address.address)) {
      if (haveValue(place?.vicinity)) {
        address.address = place?.vicinity;
        address.address = address.address.split(",");
        address.address.pop();
        address.address = address.address.join(", ");
      }
    }

    handleFormikChange(place?.formatted_phone_number, form, "businessPhone");

    handleFormikChange(address?.address, form, "businessAddress");
    handleFormikChange(address?.city, form, "city");
    handleFormikChange(address?.stateShort, form, "state");
    handleFormikChange(address?.countryShort, form, "country");

    handleFormikChange(address?.zipCode, form, "zipcode");

    if (haveValue(address?.countryShort)) {
      loadStates(address?.countryShort);
    }

    setTimeout((e) => {
      let input: any = document.querySelector("#businessNameField input");
      if (input != null) {
        input.value = place?.name;
        handleFormikChange(place?.name, form, "businessName");
      }
    }, 500);

    if (haveValue(place?.website)) {
      handleFormikChange(place?.website, form, "website");
    }

    if (haveValue(place.types)) {
      let businessTypes: any = [];

      if (place.types.length > 0) {
        for (let businessType of place.types) {
          businessTypes.push(underScoredToNormal(businessType));
        }
      }

      if (businessTypes.length > 0) {
        matchBusinessCategories({
          items: businessTypes,
        })
          .then((res: any) => {
            let categories: any = [];
            let data = res?.data;
            let matchedItem: any = null;
            if (data.length > 0) {
              for (let item of data) {
                categories.push({
                  value: item?.name,
                  label: item?.name,
                });
                if (data.length === 1) {
                  matchedItem = item;
                }
              }
            }

            setDefaultBusinessCats(categories);
            setTimeout((e) => {
              let businessType = "";
              if (matchedItem !== null) {
                businessType = matchedItem.name;
              }
              handleFormikChange(
                underScoredToNormal(businessType),
                form,
                "businessCategory"
              );
            }, 500);
          })
          .catch((err: any) => {});
      }
    }
  };

  if (!showCategory) {
    if (Boolean(form.errors.zipcode)) {
      setShowCategory(true);
    }
    if (
      Boolean(form.errors.businessCategory) &&
      form.touched.businessCategory
    ) {
      setShowCategory(true);
    }
  }

  const handleAddressChange = (e) => {
    handleFormikChange(e, form);
    const address = e?.target?.value;
    if (haveValue(address)) {
      const addressDataD = address.split(",");
      const addressData = addressDataD
        .filter((item) => item.trim() !== "") // Remove empty values
        .map((item) => item.trim()); // Trim the remaining values
      console.log(addressData.length);
      console.log(addressData);
      switch (addressData.length) {
        case 2:
          handleFormikChange(addressData[1], form, "city");
          break;
        case 3:
          handleFormikChange(addressData[1], form, "city");
          handleFormikChange(addressData[2], form, "state");
          break;
        case 4:
          handleFormikChange(addressData[1], form, "city");
          handleFormikChange(addressData[2], form, "state");
          handleFormikChange(addressData[3], form, "country");
          break;
      }
    }
  };

  return (
    <>
      <Modal
        className="performance-modal custom-modal-design"
        show={showContactInfoModal}
        onHide={handleModalClose}
      >
        <Modal.Header closeButton>
          <Modal.Title>Where do we send your results?</Modal.Title>
        </Modal.Header>
        <Modal.Body className="scan-now">
          <Form
            className="performance-form"
            onSubmit={(e) => handleFormikSubmit(e, form2)}
          >
            <div className="form-fields-body">
              <Row>
                <Col md={12}>
                  <FormField
                    id="name"
                    name="name"
                    icon="fa fa-user-o"
                    value={form2.values.name}
                    onChange={(e) => handleFormikChange(e, form2)}
                    showError={form2.touched.name}
                    errorText={form2.errors.name}
                    placeholder={"Enter Name"}
                  />
                </Col>
                <Col md={12}>
                  <FormField
                    id="email"
                    name="email"
                    icon="fa fa-envelope-o"
                    fieldType="email"
                    value={form2.values.email}
                    onChange={(e) => handleFormikChange(e, form2)}
                    showError={form2.touched.email}
                    errorText={form2.errors.email}
                    placeholder={"Enter Email"}
                  />
                </Col>
              </Row>
            </div>
            <button className="scan-btn lead-crease-btn" type="submit">
              Show me the Results!
            </button>
          </Form>
        </Modal.Body>
      </Modal>
      <Form
        className="lead-crease-form-box form-custom-form"
        onSubmit={(e) => handleFormikSubmit(e, form)}
      >
        <Form.Group className="mb-3 ">
          <div className="theme-forminput " id="businessNameField">
            <div className="input-group">
              <span className="input-group-text" id="basic-addon1">
                <i className="fa fa-user" aria-hidden="true"></i>
              </span>
              <Autocomplete
                apiKey={vendor.googleMapApi}
                onPlaceSelected={(place, ref) => {
                  onPlaceSelect(place, ref);
                }}
                onChange={(e) => {
                  const tEl: any = document.querySelector(".pac-target-input");
                  if (tEl != null) {
                    handleFormikChange(tEl.value, form, "businessName");
                  }
                }}
                options={{
                  types: [],
                  fields: [
                    "address_components",
                    "formatted_phone_number",
                    "name",
                    "vicinity",
                    "website",
                    "type",
                  ],
                }}
                className="form-control"
                // placeholder='Company Name'
                defaultValue={form.values.businessName}
              />
            </div>
          </div>
        </Form.Group>
        <Form.Group className="mb-3">
          <FormField
            id="businessAddress"
            name="businessAddress"
            icon="fa fa-map"
            label={"Company Address"}
            value={form.values.businessAddress}
            onChange={(e) => handleAddressChange(e)}
            showError={form.touched.businessAddress}
            errorText={form.errors.businessAddress}
            placeholder={"Company Address"}
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <FormField
            id="businessPhone"
            name="businessPhone"
            icon="fa fa-phone"
            label={"Company Phone Number"}
            value={form.values.businessPhone}
            onChange={(e) => handleFormikChange(e, form)}
            showError={form.touched.businessPhone}
            errorText={form.errors.businessPhone}
            placeholder={"Company Phone Number"}
          />
        </Form.Group>
        {showCategory && (
          <Form.Group className="mb-3">
            <FormField
              id="zipcode"
              name="zipcode"
              icon="fa fa-location-arrow"
              label={"Zipcode"}
              value={form.values.zipcode}
              onChange={(e) => handleFormikChange(e, form)}
              showError={form.touched.zipcode}
              errorText={form.errors.zipcode}
              placeholder={"Enter Zipcode"}
            />
          </Form.Group>
        )}
        <div className="text-center">
          <button type="submit" className="lead-crease-btn">
            SCAN NOW
          </button>
        </div>
      </Form>
    </>
  );
};

export default Step1Form;
